export default __webpack_public_path__ + "static/media/allgemein_41.fea947aa.jpg";